import { render, staticRenderFns } from "./ServicesEdit.vue?vue&type=template&id=18d67a84&"
import script from "./ServicesEdit.vue?vue&type=script&lang=js&"
export * from "./ServicesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports